import { schemaLibraryId } from '../fixture-ids';

export const schemaLibraryEntries = {
  SCHEMA_LIBRARY_CREATED: {
    entity: 'schemaLibrary',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: true,
  },
  // The current writer emits 'id'; legacy rows carry 'schemaLibraryId' for the same table. The
  // legacy alternate declares that alias, so the composed entry resolves either.
  SCHEMA_LIBRARY_UPDATED: {
    entity: 'schemaLibrary',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
  },
  // Same legacy id-key difference as SCHEMA_LIBRARY_UPDATED.
  SCHEMA_LIBRARY_DELETED: {
    entity: 'schemaLibrary',
    identity: 'record',
    idKeys: ['id'],
    renderMode: 'diff',
    createsRecord: false,
  },
  // Legacy rows reuse this key for a schema_library_versions.id. Only the current generation
  // carries 'version' (legacy wrote 'description'), so whenKey keeps legacy rows from resolving
  // against schema_libraries and silently reading as pruned.
  SCHEMA_LIBRARY_PUBLISHED: {
    entity: 'schemaLibrary',
    identity: 'record',
    idKeys: [{ key: 'schemaLibraryId', whenKey: 'version' }],
    renderMode: 'diff',
    createsRecord: false,
    keyAliases: { description: 'version' },
    foreignDisplayKeys: ['name'],
  },
};

export const schemaLibraryFixtures = {
  SCHEMA_LIBRARY_CREATED: {
    action: 'SCHEMA_LIBRARY_CREATED',
    debugData: { id: schemaLibraryId, name: 'Core Events', description: 'Shared library for core events' },
  },
  SCHEMA_LIBRARY_UPDATED: {
    action: 'SCHEMA_LIBRARY_UPDATED',
    debugData: { id: schemaLibraryId, name: 'Core Events', description: 'Shared library for core events (revised)' },
  },
  SCHEMA_LIBRARY_DELETED: {
    action: 'SCHEMA_LIBRARY_DELETED',
    debugData: { id: schemaLibraryId, name: 'Core Events', description: 'Shared library for core events (revised)' },
  },
  SCHEMA_LIBRARY_PUBLISHED: {
    action: 'SCHEMA_LIBRARY_PUBLISHED',
    debugData: { schemaLibraryId, name: 'Core Events', version: 3 },
  },
  // Synthetic: no real row carries both 'description' and 'version'. It exercises the
  // alias-collision path, which only arises when a predecessor from one generation is compared
  // with a row from the other.
  SCHEMA_LIBRARY_PUBLISHED_ALIAS_COLLISION: {
    action: 'SCHEMA_LIBRARY_PUBLISHED',
    debugData: { schemaLibraryId, name: 'Core Events', version: 3, description: '3' },
  },
};
